import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createNewPanelInTabDashboard as mutation } from "../modules/CustomDashboardModule/services/DashboardConfigurationService";

/**
 * Creates a callable method to pass in a on click
 * @param {Object} props - The module's config so this hook knows what to update and read
 * @param {function} props.selector - active tab id selector
 * @param {function} props.onResponse - response handler
 * @param {function} props.onLoading - loading state handler
 * @param {function} props.onError - error state handler
 * @returns {Object} That contains a function to be called in an `onClick` event
 */
export const useAddPanelToTabMutation = ({
  selector,
  onLoading,
  onError,
  onResponse,
}) => {
  const dispatch = useDispatch();
  const activeTabId = useSelector(selector);

  const addPanelInTab = useCallback(
    async (panelData = {}) => {
      try {
        dispatch(onLoading(true));

        const panel = await mutation(panelData, activeTabId);

        onResponse?.(panel);

        return panel;
      } catch (error) {
        dispatch(onError(error));
      } finally {
        dispatch(onLoading(false));
      }
    },
    [activeTabId]
  );

  return { addPanelInTab };
};
